"use client";

import Link from "next/link";
import { Icon } from "@/components/ui/Icon";
import type { HeaderMenuItem } from "./headerModel";

interface HeaderIconMenuProps {
    /** Resolved menu items with icon node data */
    items: HeaderMenuItem[];
    /** Base path for relative URLs */
    basePath: string;
    /** Color variant matching SearchToggle/AuthControls */
    variant?: "light" | "branded" | "dark";
    /** Icon size in pixels */
    iconSize?: number;
    /** Max items to show (for mobile capping) */
    maxItems?: number;
}

export function HeaderIconMenu({ items, basePath, variant = "light", iconSize = 18, maxItems }: HeaderIconMenuProps) {
    // Filter to only items that have a resolved icon
    const iconItems = items.filter((item) => item.iconNode);

    if (iconItems.length === 0) return null;

    const displayItems = maxItems ? iconItems.slice(0, maxItems) : iconItems;

    const textClass =
        variant === "light" ? "text-white" : variant === "branded" ? "text-primary-foreground" : "text-foreground";

    const hoverBgClass =
        variant === "light"
            ? "hover:bg-white/10"
            : variant === "branded"
              ? "hover:bg-primary-foreground/10"
              : "hover:bg-muted";

    return (
        <div className="flex items-center gap-1">
            {displayItems.map((item, index) => (
                <Link
                    key={index}
                    href={item.url.startsWith("http") ? item.url : `${basePath}${item.url}`}
                    prefetch={false}
                    target={item.openInNewTab ? "_blank" : undefined}
                    className={`p-2 rounded-lg ${hoverBgClass} transition ${textClass}`}
                    aria-label={item.label}
                >
                    <Icon node={item.iconNode!} size={iconSize} />
                </Link>
            ))}
        </div>
    );
}
